import React, { Component } from "react"
import Avatar from "@material-ui/core/Avatar"
import Button from "@material-ui/core/Button"
import CssBaseline from "@material-ui/core/CssBaseline"
import TextField from "@material-ui/core/TextField"
import Box from "@material-ui/core/Box"
import LockOutlinedIcon from "@material-ui/icons/LockOutlined"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert } from "@material-ui/lab"
import * as constants from "../constants"
import { Redirect } from "react-router-dom"

const styles = (theme) => ({
      paper: {
            marginTop: theme.spacing(8),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
      },
      form: {
            width: "100%", // Fix IE 11 issue.
            marginTop: theme.spacing(1),
            direction: "ltr",
      },
      label: {
            direction: "rtl",
            width: "100%", // Fix IE 11 issue.
      },
      submit: {
            margin: theme.spacing(3, 0, 2),
      },
})

class ForgetPass extends Component {
      cookies = new Cookies()

      cookies = new Cookies()
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  mobile: "",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  temp: null,
            }
      }

      componentDidMount() {}

      handleChangemobile = (event) => {
            this.setState({ mobile: event.target.value })
      }

      submit = (e) => {
            const { mobile } = this.state
            if (mobile === "") {
                  this.setState({ snackstr: "شماره همراه خود را وارد نمایید.", showSnack: true, snackMode: "error" })
            } else {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ redirect: true })
                              } else {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "forgetpasstell")
                  fd.append("employee_mobile", mobile)

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            }
      }
      render() {
            const { classes } = this.props
            const { snackMode, snackstr, mobile, showSnack, redirect } = this.state
            if (redirect) {
                  return <Redirect to="/login" />
            } else {
                  return (
                        <Container component="main" maxWidth="xs">
                              <CssBaseline />
                              <div className={classes.paper}>
                                    <Avatar className={classes.avatar}>
                                          <LockOutlinedIcon />
                                    </Avatar>
                                    <Typography component="h1" variant="h5">
                                          فراموشی رمز عبور
                                    </Typography>
                                    <form className={classes.form} noValidate>
                                          <TextField
                                                variant="outlined"
                                                margin="normal"
                                                required
                                                fullWidth
                                                id="mobile"
                                                label="شماره همراه"
                                                name="mobile"
                                                autoComplete="mobile"
                                                autoFocus
                                                value={mobile}
                                                onChange={this.handleChangemobile}
                                          />

                                          <Button onClick={this.submit} fullWidth variant="contained" color="primary" className={classes.submit}>
                                                ارسال رمز به همراه
                                          </Button>
                                    </form>
                              </div>
                              <Box mt={8}></Box>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                        </Container>
                  )
            }
      }
}

export default withStyles(styles)(ForgetPass)
